import {z} from 'zod';

import {iamQueryParams} from '@dms/routes';

const REDIRECT_SEARCH_PARAMS_SCHEMA = z.object({
  code: z.string().min(1),
  origin_href: z.string().url(),
  workspace: z.string().min(1),
});

type RedirectSearchParams = z.infer<typeof REDIRECT_SEARCH_PARAMS_SCHEMA>;

export const getRedirectSearchParams = (): [true, RedirectSearchParams] | [false, null] => {
  const searchParams = new URLSearchParams(window.location.search);

  const params = {
    code: searchParams.get(iamQueryParams.CODE),
    origin_href: searchParams.get(iamQueryParams.ORIGIN_URI),
    workspace: searchParams.get(iamQueryParams.WORKSPACE),
  };

  const result = REDIRECT_SEARCH_PARAMS_SCHEMA.safeParse(params);

  if (result.success) {
    return [true, result.data];
  }

  return [false, null];
};
